import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import PropertyCard from "@/components/PropertyCard";
import SearchFilters from "@/components/SearchFilters";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Properties = () => {
  const [searchParams] = useSearchParams();
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({});

  useEffect(() => {
    const initialFilters = {};
    searchParams.forEach((value, key) => {
      initialFilters[key] = value;
    });
    setFilters(initialFilters);
    fetchProperties(initialFilters);
  }, [searchParams]);

  const fetchProperties = async (searchFilters) => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams(searchFilters).toString();
      const response = await axios.get(`${API}/properties/search?${queryParams}`);
      setProperties(response.data);
    } catch (error) {
      console.error('Error fetching properties:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (newFilters) => {
    setFilters(newFilters);
    fetchProperties(newFilters);
  };

  return (
    <div data-testid="properties-page">
      <section className="bg-primary text-primary-foreground py-16">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 text-center">
          <h1 className="text-4xl md:text-5xl font-heading font-bold mb-4">Find Your Perfect Property</h1>
          <p className="text-lg text-primary-foreground/90">Browse our exclusive listings across the Greater Toronto Area</p>
        </div>
      </section>

      <section className="py-12 bg-secondary/30">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          <SearchFilters onSearch={handleSearch} initialFilters={filters} />
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
          {loading ? (
            <div className="text-center py-20" data-testid="loading-indicator">
              <p className="text-muted-foreground text-lg">Loading properties...</p>
            </div>
          ) : properties.length === 0 ? (
            <div className="text-center py-20" data-testid="no-results">
              <p className="text-muted-foreground text-lg mb-4">No properties found matching your criteria.</p>
              <p className="text-muted-foreground">Try adjusting your search filters.</p>
            </div>
          ) : (
            <>
              <div className="mb-8">
                <p className="text-lg text-muted-foreground" data-testid="results-count">
                  Showing <span className="font-semibold text-primary">{properties.length}</span> properties
                </p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {properties.map((property) => (
                  <PropertyCard key={property.mls_number} property={property} />
                ))}
              </div>
            </>
          )}
        </div>
      </section>
    </div>
  );
};

export default Properties;